<template>
  <div class="absolute right-8 top-1/2 flex center gap-4 <md:hidden -translate-y-1/2">
    <!-- Find a store -->
    <base-link
      :aria-label="$t.findStore"
      class="flex center gap-1.5 c-$c duration hover:c-$ch"
      to="/store-locator"
    >
      <vf-icon name="location" />
    </base-link>

    <!-- Language / Location selector -->
    <base-link
      :aria-label="$t.locationSelector"
      class="flex center gap-2 c-$c duration hover:c-$ch"
      to="/location-selector"
      @click="$gtm.push('topNav.onClickCountrySelector')"
    >
      <vf-location-flag />
      <span class="hidden text-xs lg:inline">{{ languageCode }}</span>
    </base-link>

    <!-- Help -->
    <base-link
      :aria-label="$t.help"
      class="flex center gap-1.5 c-$c duration hover:c-$ch"
      to="/help"
    >
      <vf-icon name="help" />
    </base-link>
  </div>
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()
const languageCode = useLanguageCode()
</script>
